import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroupActions as getGroupActionsAPI} from '../../../services/groups'

export async function getGroupActions(dispatch, {group_id, params = {}}) {
  try {
    dispatch({type: PENDING})
    let response = await getGroupActionsAPI({group_id, params})
    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Group Actions Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
  }
}
